"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoAspectRatio = exports.VideoAspectRatioMode = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var video_aspect_ratio_scss_1 = tslib_1.__importDefault(require("./video-aspect-ratio.scss"));
var VideoAspectRatioMode;
(function (VideoAspectRatioMode) {
    VideoAspectRatioMode["FIT_TO_HEIGHT"] = "FIT_TO_HEIGHT";
    VideoAspectRatioMode["FIT_TO_WIDTH"] = "FIT_TO_WIDTH";
})(VideoAspectRatioMode = exports.VideoAspectRatioMode || (exports.VideoAspectRatioMode = {}));
var stylesMap = (_a = {},
    _a[VideoAspectRatioMode.FIT_TO_HEIGHT] = video_aspect_ratio_scss_1.default.fitToheight,
    _a[VideoAspectRatioMode.FIT_TO_WIDTH] = video_aspect_ratio_scss_1.default.fitToWidth,
    _a);
var image16x9 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAIAAAC0SDtlAAAAGklEQVQYlWP8//8/AymAiSTVoxpoooGBgQEAMWADDx3noXgAAAAASUVORK5CYII=';
var VideoAspectRatio = /** @class */ (function (_super) {
    tslib_1.__extends(VideoAspectRatio, _super);
    function VideoAspectRatio() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VideoAspectRatio.prototype.render = function () {
        var _a = this.props, children = _a.children, mode = _a.mode;
        return (react_1.default.createElement("div", { className: video_aspect_ratio_scss_1.default.container },
            react_1.default.createElement("img", { className: (0, classnames_1.default)(video_aspect_ratio_scss_1.default.ratioImage, stylesMap[mode]), src: image16x9, alt: "", "aria-hidden": "true" }),
            children));
    };
    VideoAspectRatio.propTypes = {
        children: prop_types_1.default.any,
        mode: prop_types_1.default.oneOf([
            VideoAspectRatioMode.FIT_TO_HEIGHT,
            VideoAspectRatioMode.FIT_TO_WIDTH,
        ]),
    };
    VideoAspectRatio.defaultProps = {
        mode: VideoAspectRatioMode.FIT_TO_WIDTH,
    };
    return VideoAspectRatio;
}(react_1.default.Component));
exports.VideoAspectRatio = VideoAspectRatio;
//# sourceMappingURL=video-aspect-ratio.js.map